import OverviewSection from "@Components/game/session-results/overview/overview-section";
import { useSessionResultsTabContext } from "@Context/game/activity/session-results-context";
import useExitBootcamp from "@hooks/game/bootcamp/use-exit-bootcamp";
import useI18n from "@i18n";
import { Button, Stack, Typography } from "@mui/material";

const BootcampFinalCompletion = () => {
  const { i18n } = useI18n();
  const { currentTab } = useSessionResultsTabContext();
  const exitBootcamp = useExitBootcamp();

  return (
    <Stack gap={4}>
      {currentTab === 0 && (
        <Stack alignItems="center" textAlign="center" gap={1.25} paddingTop={4}>
          <Typography variant="text5xl700" color="common.white">
            {i18n("session-results.bootcamp-complete.title")}
          </Typography>
          <Typography variant="text1xl400" color="dsNeutral.v300" maxWidth={650} lineHeight={1.5}>
            {i18n("session-results.bootcamp-complete.description")}
          </Typography>
          <Button size="small" data-shape="pill" onClick={exitBootcamp} sx={{ marginTop: 1 }}>
            {i18n("session-results.bootcamp-complete.continue")}
          </Button>
        </Stack>
      )}

      <OverviewSection />
    </Stack>
  );
};

export default BootcampFinalCompletion;
